import { FC, ReactNode } from "react";
import Base from "../Base";

const DefaultLayout: FC<{ children: ReactNode }> = ({ children }) => {
  return <Base>{children}</Base>;
};

export default DefaultLayout;
